import "core-js/modules/es6.map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.for-each.js";
import createEventHandle from '../createEventHandle';
import useLayoutEffect from '../useLayoutEffect';
import useStable from '../useStable';
export default function useEvent(event, options) {
  var targetListeners = useStable(function () {
    return new Map();
  });
  var addListener = useStable(function () {
    var addEventListener = createEventHandle(event, options);
    return function (target, callback) {
      var removeTargetListener = targetListeners.get(target);

      if (removeTargetListener != null) {
        removeTargetListener();
      }

      if (callback == null) {
        targetListeners["delete"](target);
      }

      var removeEventListener = addEventListener(target, callback);
      targetListeners.set(target, removeEventListener);
      return removeEventListener;
    };
  });
  useLayoutEffect(function () {
    return function () {
      if (addListener != null) {
        targetListeners.forEach(function (removeListener) {
          removeListener();
        });
        targetListeners.clear();
      }

      addListener = null;
    };
  }, [addListener]);
  return addListener;
}